export default "__VITE_ASSET__nrmNlInj__"